export const contentSelector = (state) => state.homepage.content;
